import React, { useState } from "react";
import { FALLBACK } from "../../data/images";

// Image with graceful fallback. Renders fully visible immediately (no JS
// opacity gating) so it is robust against re-renders; broken sources swap to
// a verified fallback rather than showing a broken icon.
export function Img({
  src,
  alt = "",
  className = "",
  priority = false,
  ...rest
}) {
  const [errored, setErrored] = useState(false);

  return (
    <img
      src={errored ? FALLBACK : src}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      onError={() => setErrored(true)}
      className={className}
      {...rest}
    />
  );
}
